import * as i0 from '@angular/core';
import { Directive, ViewChild, Component, EventEmitter, Input, Output, Injectable, Optional, APP_INITIALIZER, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i3 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i1$1 from '@lvflanders/bar-ng-ui';
import { BarToastMessageType, BarControlsModule } from '@lvflanders/bar-ng-ui';
import * as i2$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i2$2 from '@danielmoncada/angular-datetime-picker';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i6 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i1$2 from '@lvflanders/bar-ng-i18n';
import { BarI18nModule } from '@lvflanders/bar-ng-i18n';
import * as i3$1 from '@ng-select/ng-select';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import * as i1$4 from '@lvflanders/bar-ng';
import { resolveValue$, BAR_INITIALIZED } from '@lvflanders/bar-ng';
import * as i1$3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@ng-select/ng-option-highlight';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import * as i5$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReplaySubject } from 'rxjs';
import * as i2$3 from '@lvflanders/bar';
import { BarGvkStorageMode } from '@lvflanders/bar';
import * as i4$1 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import { LicenseManager } from 'ag-grid-enterprise';

/** Represents a keycode. */
var BarKeyCode;
(function (BarKeyCode) {
    BarKeyCode[BarKeyCode["Backspace"] = 8] = "Backspace";
    BarKeyCode[BarKeyCode["Enter"] = 13] = "Enter";
    BarKeyCode[BarKeyCode["End"] = 35] = "End";
    BarKeyCode[BarKeyCode["Home"] = 36] = "Home";
    BarKeyCode[BarKeyCode["LeftArrow"] = 37] = "LeftArrow";
    BarKeyCode[BarKeyCode["UpArrow"] = 38] = "UpArrow";
    BarKeyCode[BarKeyCode["RightArrow"] = 39] = "RightArrow";
    BarKeyCode[BarKeyCode["DownArrow"] = 40] = "DownArrow";
    BarKeyCode[BarKeyCode["Delete"] = 46] = "Delete";
})(BarKeyCode || (BarKeyCode = {}));

/** Base class for input-based editor components. */
class BarBaseInputCellEditor {
    agInit(params) {
        this.params = params;
        // here we pass the formControl or create one to make the view work
        this.formControl = params.formControl || new FormControl(params.value);
        this.onInit();
    }
    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            const focusedCell = this.params.api.getFocusedCell();
            if (focusedCell != null && focusedCell.column == this.params.column) {
                this.input.nativeElement.focus();
            }
            if (this.params.charPress) {
                this.onHandleCharPress(this.params.charPress);
            }
        });
    }
    getValue() {
        return this.formControl.value;
    }
    isPopup() {
        return false;
    }
    onKeyDown(event) {
        const key = event.which || event.keyCode;
        switch (key) {
            case BarKeyCode.Enter: {
                event.preventDefault();
                event.stopPropagation();
                if (this.params.column.gridOptionsWrapper.isEnterMovesDownAfterEdit()) {
                    // naar volgende cell gaan indien zo geconfigureerd
                    this.params.api.setFocusedCell(this.params.rowIndex + 1, this.params.column.getColId());
                }
                else {
                    // NOTE here we use a timeout because if we stopEditing while having stopEditingWhenGridLosesFocus: true then it would give an error and fail completely (used with editType: 'fullRow')
                    window.setTimeout(() => {
                        this.params.api.stopEditing(false);
                    });
                    // anders default gedrag
                    this.params.api.setFocusedCell(this.params.rowIndex, this.params.column.getColId());
                }
                break;
            }
        }
    }
    focusIn() {
        this.input.nativeElement.focus();
        this.input.nativeElement.select();
    }
    onInit() { }
    onHandleCharPress(charPress) { }
}
BarBaseInputCellEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarBaseInputCellEditor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BarBaseInputCellEditor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: BarBaseInputCellEditor, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarBaseInputCellEditor, decorators: [{
            type: Directive
        }], propDecorators: { input: [{
                type: ViewChild,
                args: ['input']
            }] } });

/** AG grid editor for auto numeric fields. */
class BarAutoNumericCellEditor extends BarBaseInputCellEditor {
    onInit() {
        this.options = this.params.options;
    }
    onHandleCharPress(charPress) {
        if (/\d/.test(charPress)) {
            this.formControl.setValue(parseInt(charPress));
        }
    }
}
BarAutoNumericCellEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAutoNumericCellEditor, deps: null, target: i0.ɵɵFactoryTarget.Component });
BarAutoNumericCellEditor.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarAutoNumericCellEditor, selector: "bar-auto-numeric-cell-editor", usesInheritance: true, ngImport: i0, template: "<mat-form-field class=\"w-100\">\r\n    <input matInput\r\n           [attr.aria-label]=\"params.colDef.headerName\"\r\n           [formControl]=\"formControl\"\r\n           [barAutoNumeric]=\"options\"\r\n           #input\r\n           (keydown)=\"onKeyDown($event)\" />\r\n</mat-form-field>\r\n", dependencies: [{ kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i1$1.BarAutoNumericDirective, selector: "input[barAutoNumeric]", inputs: ["barAutoNumeric", "disabled"], exportAs: ["barAutoNumeric"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAutoNumericCellEditor, decorators: [{
            type: Component,
            args: [{ selector: 'bar-auto-numeric-cell-editor', template: "<mat-form-field class=\"w-100\">\r\n    <input matInput\r\n           [attr.aria-label]=\"params.colDef.headerName\"\r\n           [formControl]=\"formControl\"\r\n           [barAutoNumeric]=\"options\"\r\n           #input\r\n           (keydown)=\"onKeyDown($event)\" />\r\n</mat-form-field>\r\n" }]
        }] });

/** Checkbox editor component. */
class BarCheckboxCellEditor {
    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.input.focus();
        });
    }
    agInit(params) {
        this.params = params;
        // here we pass the formControl or create one to make the view work
        this.formControl = params.formControl || new FormControl(params.value);
    }
    getValue() {
        return this.formControl.value;
    }
    isCancelBeforeStart() {
        return false;
    }
    isCancelAfterEnd() {
        return false;
    }
    onChange(params) {
        var _a;
        this.formControl.setValue(params.checked);
        const columnId = (_a = this.params.column) === null || _a === void 0 ? void 0 : _a.getColId();
        if (columnId)
            this.params.node.setDataValue(columnId, params.checked);
        setTimeout(() => {
            this.input.focus();
        });
    }
    focusIn() {
        this.input.focus();
    }
}
BarCheckboxCellEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCheckboxCellEditor, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarCheckboxCellEditor.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarCheckboxCellEditor, selector: "bar-checkbox-cell-editor", viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<mat-checkbox [formControl]=\"formControl\"\r\n              #input\r\n              (change)=\"onChange($event)\">\r\n    <span class=\"sr-only\">{{params.text ? params.text : params.colDef.headerName}}</span>\r\n</mat-checkbox>\r\n", dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i2$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCheckboxCellEditor, decorators: [{
            type: Component,
            args: [{ selector: 'bar-checkbox-cell-editor', template: "<mat-checkbox [formControl]=\"formControl\"\r\n              #input\r\n              (change)=\"onChange($event)\">\r\n    <span class=\"sr-only\">{{params.text ? params.text : params.colDef.headerName}}</span>\r\n</mat-checkbox>\r\n" }]
        }], propDecorators: { input: [{
                type: ViewChild,
                args: ['input']
            }] } });

class BarDateTimeCellEditor extends BarBaseInputCellEditor {
    onInit() {
        this.pickerType = this.params.pickerType || 'calendar';
        this.pickerMode = this.params.pickerMode || 'popup';
    }
    onHandleCharPress(charPress) {
        if (/\d/.test(charPress)) {
            this.input.nativeElement.value = charPress;
        }
    }
}
BarDateTimeCellEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarDateTimeCellEditor, deps: null, target: i0.ɵɵFactoryTarget.Component });
BarDateTimeCellEditor.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarDateTimeCellEditor, selector: "bar-date-time-cell-editor", usesInheritance: true, ngImport: i0, template: "<mat-form-field class=\"w-100\">\r\n    <input\r\n        #input\r\n        matInput\r\n        [attr.aria-label]=\"params.colDef.headerName\"\r\n        [formControl]=\"formControl\"\r\n        [owlDateTime]=\"datePicker\"\r\n        autocomplete=\"off\"\r\n        (keydown)=\"onKeyDown($event)\"\r\n        [min]=\"params.minDate\"\r\n        [max]=\"params.maxDate\"\r\n        [owlDateTimeFilter]=\"params.dateTimeFilter\"\r\n    />\r\n    <button mat-icon-button matSuffix [owlDateTimeTrigger]=\"datePicker\" [attr.aria-label]=\"'DOMAIN_BAR_AG_GRID.CHOOSE_DATE' | translate\" type=\"button\">\r\n        <mat-icon fontSet=\"fas\" fontIcon=\"fa-calendar\"></mat-icon>\r\n    </button>\r\n    <owl-date-time\r\n        #datePicker\r\n        [pickerType]=\"pickerType\"\r\n        [firstDayOfWeek]=\"1\"\r\n        [pickerMode]=\"pickerMode\"\r\n        [showSecondsTimer]=\"params.includeSeconds\"\r\n    ></owl-date-time>\r\n</mat-form-field>\r\n", dependencies: [{ kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.OwlDateTimeTriggerDirective, selector: "[owlDateTimeTrigger]", inputs: ["owlDateTimeTrigger", "disabled"] }, { kind: "directive", type: i2$2.OwlDateTimeInputDirective, selector: "input[owlDateTime]", inputs: ["required", "owlDateTime", "owlDateTimeFilter", "_disabled", "min", "max", "selectMode", "rangeSeparator", "value", "values"], outputs: ["dateTimeChange", "dateTimeInput"], exportAs: ["owlDateTimeInput"] }, { kind: "component", type: i2$2.OwlDateTimeComponent, selector: "owl-date-time", inputs: ["backdropClass", "panelClass", "startAt", "endAt", "pickerType", "pickerMode", "disabled", "opened", "scrollStrategy"], outputs: ["afterPickerClosed", "afterPickerOpen", "yearSelected", "monthSelected", "dateSelected"], exportAs: ["owlDateTime"] }, { kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: i1$2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarDateTimeCellEditor, decorators: [{
            type: Component,
            args: [{ selector: 'bar-date-time-cell-editor', template: "<mat-form-field class=\"w-100\">\r\n    <input\r\n        #input\r\n        matInput\r\n        [attr.aria-label]=\"params.colDef.headerName\"\r\n        [formControl]=\"formControl\"\r\n        [owlDateTime]=\"datePicker\"\r\n        autocomplete=\"off\"\r\n        (keydown)=\"onKeyDown($event)\"\r\n        [min]=\"params.minDate\"\r\n        [max]=\"params.maxDate\"\r\n        [owlDateTimeFilter]=\"params.dateTimeFilter\"\r\n    />\r\n    <button mat-icon-button matSuffix [owlDateTimeTrigger]=\"datePicker\" [attr.aria-label]=\"'DOMAIN_BAR_AG_GRID.CHOOSE_DATE' | translate\" type=\"button\">\r\n        <mat-icon fontSet=\"fas\" fontIcon=\"fa-calendar\"></mat-icon>\r\n    </button>\r\n    <owl-date-time\r\n        #datePicker\r\n        [pickerType]=\"pickerType\"\r\n        [firstDayOfWeek]=\"1\"\r\n        [pickerMode]=\"pickerMode\"\r\n        [showSecondsTimer]=\"params.includeSeconds\"\r\n    ></owl-date-time>\r\n</mat-form-field>\r\n" }]
        }] });

/** AG grid editor for regular input fields. */
class BarInputCellEditor extends BarBaseInputCellEditor {
    onHandleCharPress(charPress) {
        this.formControl.setValue(charPress);
    }
}
BarInputCellEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarInputCellEditor, deps: null, target: i0.ɵɵFactoryTarget.Component });
BarInputCellEditor.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarInputCellEditor, selector: "bar-input-cell-editor", usesInheritance: true, ngImport: i0, template: "<mat-form-field class=\"w-100\">\r\n    <input matInput\r\n           [attr.aria-label]=\"params.colDef.headerName\"\r\n           [formControl]=\"formControl\"\r\n           type=\"text\"\r\n           #input\r\n           (keydown)=\"onKeyDown($event)\"\r\n           [attr.maxLength]=\"params.maxLength\" />\r\n</mat-form-field>\r\n", dependencies: [{ kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarInputCellEditor, decorators: [{
            type: Component,
            args: [{ selector: 'bar-input-cell-editor', template: "<mat-form-field class=\"w-100\">\r\n    <input matInput\r\n           [attr.aria-label]=\"params.colDef.headerName\"\r\n           [formControl]=\"formControl\"\r\n           type=\"text\"\r\n           #input\r\n           (keydown)=\"onKeyDown($event)\"\r\n           [attr.maxLength]=\"params.maxLength\" />\r\n</mat-form-field>\r\n" }]
        }] });

/** AG grid editor for selecting items in a dropdown through ng-select. */
class BarSelectCellEditor {
    constructor(zone) {
        this.zone = zone;
    }
    agInit(params) {
        this.params = params;
        this.formControl = params.formControl || new FormControl(params.value);
        const items$ = resolveValue$(this.params.items);
        this.itemsSubscription = items$.subscribe((items) => {
            this.items = items;
        });
    }
    ngOnDestroy() {
        // make sure to unsubscribe to the items observable because we never know what is behind (something uncompleted)
        this.itemsSubscription.unsubscribe();
    }
    ngAfterViewInit() {
        // automatically set the focus when the column gets in edit modus (the editor is then initialized)
        const focusedCell = this.params.api.getFocusedCell();
        // only perform this if this is the column having the focus (fullRowEdit modus)
        if ((focusedCell === null || focusedCell === void 0 ? void 0 : focusedCell.column) == this.params.column) {
            // NOTE the timeout is needed to have effect
            setTimeout(() => {
                this.input.focus();
                // when the editor gets the focus (in read modus) and we type a character we want to start filtering already
                if (this.params.charPress && this.checkAlfaNumeric(this.params.charPress)) {
                    this.input.filter(this.params.charPress);
                }
            });
        }
        if (this.params.exitEditOnSelect) {
            this.input.openEvent.subscribe(() => {
                if (this.input.isOpen) {
                    // NOTE the timeout is needed to have effect
                    window.setTimeout(() => {
                        this.input.dropdownPanel.contentElementRef.nativeElement.addEventListener('click', this.onHandleDropDownPanelClick.bind(this));
                    });
                }
            });
        }
        if (this.params.clearAllText)
            this.input.clearAllText = this.params.clearAllText;
        if (this.params.notFoundText)
            this.input.notFoundText = this.params.notFoundText;
        // only assign clearable in case we have a true boolean (otherwise it would be not clearable by default)
        if (this.params.clearable != null)
            this.input.clearable = this.params.clearable;
        if (this.params.compareWith)
            this.input.compareWith = this.params.compareWith;
    }
    getValue() {
        return this.formControl.value;
    }
    isPopup() {
        // we don't want the component to appear in a popup
        return false;
    }
    onKeyDown(event) {
        const key = event.which || event.keyCode;
        switch (key) {
            case BarKeyCode.Enter: {
                const focusedCell = this.params.api.getFocusedCell();
                if (this.params.column.gridOptionsWrapper.isEnterMovesDownAfterEdit()) {
                    // NOTE we are suppressing the enter behavior on the col def because otherwise the ng-select never gets the enter to select a value
                    // so here we must keep the default behavior in case the enter key would not have been suppressed
                    // calculate the next row index
                    const nextRowIndex = focusedCell.rowIndex + 1;
                    if (nextRowIndex < this.params.api.paginationGetRowCount()) {
                        // set the focus to the next cell
                        this.params.api.setFocusedCell(nextRowIndex, focusedCell.column);
                    }
                    else {
                        // no next row just stop editing
                        this.params.api.stopEditing();
                    }
                }
                else {
                    //  normal behavior stop editing (enter doesn't move down after edit), but keep focus
                    this.params.api.stopEditing();
                    this.params.api.setFocusedCell(focusedCell.rowIndex, focusedCell.column);
                }
                break;
            }
            case BarKeyCode.Delete: {
                // in geval van delete key en nog niets ingetyped dan veld leegmaken
                if (this.params.clearValueOnDelete && !this.input.searchTerm)
                    this.formControl.setValue(undefined);
                break;
            }
            case BarKeyCode.Backspace: {
                // in geval van backspace key en 1 karakter ingevuld  of nog niets ingetyped dan veld leegmaken
                if (this.params.clearValueOnBackspace && (!this.input.searchTerm || this.input.searchTerm.length === 1))
                    this.formControl.setValue(undefined);
                break;
            }
            case BarKeyCode.UpArrow: {
                this.arrowSelection(event, true);
                break;
            }
            case BarKeyCode.DownArrow: {
                this.arrowSelection(event, false);
                break;
            }
        }
    }
    resolveValueOptionParam(param, item) {
        if (typeof param === 'function') {
            return param(item);
        }
        else {
            return param;
        }
    }
    focusIn() {
        this.input.focus();
    }
    /**
     * Performs the logic on arrow down and arrow up.
     * @param event The original keyboard event.
     * @param up Whether going up or down.
     */
    arrowSelection(event, up) {
        // in case the input is open and arrow selection is enabled we need to handle it
        if (this.input.isOpen && this.params.enableArrowSelection) {
            // handle it stop propagating
            event.stopPropagation();
            // check if we have something in the popup
            if (this.input.itemsList.filteredItems.length > 0) {
                let selectedIndex;
                if (this.input.selectedItems[0]) {
                    // define the selected index in the list
                    selectedIndex = this.input.itemsList.filteredItems.findIndex((item) => {
                        return item.value[this.params.bindValue] === this.input.selectedItems[0].value[this.params.bindValue];
                    });
                }
                else {
                    // nothing chosen yet
                    selectedIndex = -1;
                }
                if (up) {
                    // we go up meaning we need to go higher up the list
                    selectedIndex = selectedIndex <= 0 ? this.input.itemsList.filteredItems.length - 1 : selectedIndex - 1;
                    // make the selection
                    this.makeSelection(selectedIndex);
                }
                else {
                    // we go down meaning we need to go lower in the list
                    selectedIndex = selectedIndex === this.input.itemsList.filteredItems.length - 1 ? 0 : selectedIndex + 1;
                    // make the selection
                    this.makeSelection(selectedIndex);
                }
            }
        }
    }
    /**
     * Checks whether a given value is alfanumeric.
     * @param charStr The string.
     */
    checkAlfaNumeric(charStr) {
        if (charStr && charStr.length > 1)
            return false;
        return charStr ? !!/^[a-zA-Z0-9]*$/.test(charStr) : false;
    }
    /**
     * Handles the click in the dropdown panel.
     * @param event
     */
    onHandleDropDownPanelClick(event) {
        // run in Angular zone
        this.zone.run(() => {
            // get the focussed cell
            const focusedCell = this.params.api.getFocusedCell();
            // stop editing
            this.params.api.stopEditing();
            // set focussed cell again
            this.params.api.setFocusedCell(focusedCell.rowIndex, focusedCell.column);
        });
    }
    /** Make the selection based on the selected index. */
    makeSelection(index) {
        // check if we have something to select
        if (index > -1) {
            // set the selected value (model binding)
            this.formControl.setValue(this.input.itemsList.filteredItems[index].value[this.params.bindValue]);
            // scroll to the selected index
            if (this.input.dropdownPanel)
                this.input.dropdownPanel.scrollTo(this.input.itemsList.filteredItems[index]);
            this.input.itemsList.unmarkItem();
        }
        // use a timeout to focus the input
        window.setTimeout(() => {
            this.input.focus();
        }, 0);
    }
}
BarSelectCellEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSelectCellEditor, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
BarSelectCellEditor.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarSelectCellEditor, selector: "bar-select-editor", viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true, read: NgSelectComponent }], ngImport: i0, template: "<ng-select #input\r\n           appendTo=\"body\"\r\n           [attr.aria-label]=\"params.colDef.headerName\"\r\n           [formControl]=\"formControl\"\r\n           [items]=\"items\"\r\n           [bindLabel]=\"params.bindLabel\"\r\n           [bindValue]=\"params.bindValue\"\r\n           [placeholder]=\"params.placeholder\"\r\n           [groupBy]=\"params.groupBy\"\r\n           [groupValue]=\"params.groupValue\"\r\n           [selectableGroup]=\"params.selectableGroup\"\r\n           [markFirst]=\"params.markFirst == null ? true: params.markFirst\"\r\n           [hideSelected]=\"params.hideSelected\"\r\n           [multiple]=\"params.multiple\"\r\n           [maxSelectedItems]=\"params.maxSelectedItems\"\r\n           [isOpen]=\"params.isOpen == null ? undefined : params.isOpen\"\r\n           [searchable]=\"params.searchable == null ? true : params.searchable\"\r\n           [inputAttrs]=\"params.inputAttrs\"\r\n           [selectOnTab]=\"params.selectOnTab == null ? false : params.selectOnTab\"\r\n           class=\"lv-ag-grid-ng-select--fixed-width\"\r\n           (keydown)=\"onKeyDown($event)\">\r\n    <ng-template ng-option-tmp\r\n                 let-item=\"item\"\r\n                 let-item$=\"item$\"\r\n                 let-index=\"index\"\r\n                 let-search=\"searchTerm\">\r\n        <div class=\"d-flex\">\r\n            <span *ngIf=\"params.prefixIcon && resolveValueOptionParam(params.prefixIcon.show, item)\"\r\n                  class=\"mr-2 flex-shrink-0\"\r\n                  [ngClass]=\"resolveValueOptionParam(params.prefixIcon.class, item)\"\r\n                  [matTooltip]=\"resolveValueOptionParam(params.prefixIcon.tooltip, item)\">\r\n            </span>\r\n\r\n            <ng-container *ngIf=\"params.showValue && item[params.bindValue]\">\r\n                <strong>{{item[params.bindValue]}}</strong>&nbsp;\r\n            </ng-container>\r\n            <span [ngOptionHighlight]=\"params.highlightSearchTerm ? search : ''\">\r\n                {{params.bindLabel ? item[params.bindLabel] : item}}\r\n            </span>\r\n\r\n            <span *ngIf=\"params.suffixIcon && resolveValueOptionParam(params.suffixIcon.show, item)\"\r\n                  class=\"ml-2 flex-shrink-0\"\r\n                  [ngClass]=\"resolveValueOptionParam(params.suffixIcon.class, item)\"\r\n                  [matTooltip]=\"resolveValueOptionParam(params.suffixIcon.tooltip, item)\">\r\n            </span>\r\n        </div>     \r\n    </ng-template>\r\n</ng-select>\r\n", dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$1.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i3$1.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "directive", type: i4.NgOptionHighlightDirective, selector: "[ngOptionHighlight]", inputs: ["ngOptionHighlight"] }, { kind: "directive", type: i5$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarSelectCellEditor, decorators: [{
            type: Component,
            args: [{ selector: 'bar-select-editor', template: "<ng-select #input\r\n           appendTo=\"body\"\r\n           [attr.aria-label]=\"params.colDef.headerName\"\r\n           [formControl]=\"formControl\"\r\n           [items]=\"items\"\r\n           [bindLabel]=\"params.bindLabel\"\r\n           [bindValue]=\"params.bindValue\"\r\n           [placeholder]=\"params.placeholder\"\r\n           [groupBy]=\"params.groupBy\"\r\n           [groupValue]=\"params.groupValue\"\r\n           [selectableGroup]=\"params.selectableGroup\"\r\n           [markFirst]=\"params.markFirst == null ? true: params.markFirst\"\r\n           [hideSelected]=\"params.hideSelected\"\r\n           [multiple]=\"params.multiple\"\r\n           [maxSelectedItems]=\"params.maxSelectedItems\"\r\n           [isOpen]=\"params.isOpen == null ? undefined : params.isOpen\"\r\n           [searchable]=\"params.searchable == null ? true : params.searchable\"\r\n           [inputAttrs]=\"params.inputAttrs\"\r\n           [selectOnTab]=\"params.selectOnTab == null ? false : params.selectOnTab\"\r\n           class=\"lv-ag-grid-ng-select--fixed-width\"\r\n           (keydown)=\"onKeyDown($event)\">\r\n    <ng-template ng-option-tmp\r\n                 let-item=\"item\"\r\n                 let-item$=\"item$\"\r\n                 let-index=\"index\"\r\n                 let-search=\"searchTerm\">\r\n        <div class=\"d-flex\">\r\n            <span *ngIf=\"params.prefixIcon && resolveValueOptionParam(params.prefixIcon.show, item)\"\r\n                  class=\"mr-2 flex-shrink-0\"\r\n                  [ngClass]=\"resolveValueOptionParam(params.prefixIcon.class, item)\"\r\n                  [matTooltip]=\"resolveValueOptionParam(params.prefixIcon.tooltip, item)\">\r\n            </span>\r\n\r\n            <ng-container *ngIf=\"params.showValue && item[params.bindValue]\">\r\n                <strong>{{item[params.bindValue]}}</strong>&nbsp;\r\n            </ng-container>\r\n            <span [ngOptionHighlight]=\"params.highlightSearchTerm ? search : ''\">\r\n                {{params.bindLabel ? item[params.bindLabel] : item}}\r\n            </span>\r\n\r\n            <span *ngIf=\"params.suffixIcon && resolveValueOptionParam(params.suffixIcon.show, item)\"\r\n                  class=\"ml-2 flex-shrink-0\"\r\n                  [ngClass]=\"resolveValueOptionParam(params.suffixIcon.class, item)\"\r\n                  [matTooltip]=\"resolveValueOptionParam(params.suffixIcon.tooltip, item)\">\r\n            </span>\r\n        </div>     \r\n    </ng-template>\r\n</ng-select>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }]; }, propDecorators: { input: [{
                type: ViewChild,
                args: ['input', { read: NgSelectComponent }]
            }] } });

/** AG grid editor for regular input fields. */
class BarTextareaCellEditor extends BarBaseInputCellEditor {
    isPopup() {
        return true;
    }
    afterGuiAttached() {
        // wait for ag-popup-editor component, implement the 0-timeout hack
        setTimeout(() => {
            const popup = document.querySelector('.ag-popup-editor');
            popup.style.width = this.width;
        }, 0);
    }
    onHandleCharPress(charPress) {
        this.formControl.setValue(charPress);
    }
    onInit() {
        this.rows = this.params.rows || 5;
        this.width = this.params.width || `${this.params['eGridCell']['clientWidth']}px` || '300px';
    }
}
BarTextareaCellEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarTextareaCellEditor, deps: null, target: i0.ɵɵFactoryTarget.Component });
BarTextareaCellEditor.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarTextareaCellEditor, selector: "bar-textarea-cell-editor", usesInheritance: true, ngImport: i0, template: "<mat-form-field class=\"w-100\">\r\n    <textarea\r\n        matInput\r\n        [attr.aria-label]=\"params.colDef.headerName\"\r\n        [formControl]=\"formControl\"        \r\n        #input\r\n        (keydown)=\"onKeyDown($event)\"\r\n        [attr.maxLength]=\"params.maxLength\"         \r\n        [rows]=\"params.rows\"\r\n    ></textarea>\r\n</mat-form-field>\r\n", dependencies: [{ kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarTextareaCellEditor, decorators: [{
            type: Component,
            args: [{ selector: 'bar-textarea-cell-editor', template: "<mat-form-field class=\"w-100\">\r\n    <textarea\r\n        matInput\r\n        [attr.aria-label]=\"params.colDef.headerName\"\r\n        [formControl]=\"formControl\"        \r\n        #input\r\n        (keydown)=\"onKeyDown($event)\"\r\n        [attr.maxLength]=\"params.maxLength\"         \r\n        [rows]=\"params.rows\"\r\n    ></textarea>\r\n</mat-form-field>\r\n" }]
        }] });

/** BAR ag-grid cell renderer to render a BAR action button. */
class BarActionButtonCellRenderer {
    refresh(params) {
        return false;
    }
    agInit(params) {
        this.params = params;
        let actionButton = this.params.actionButton;
        if (actionButton && actionButton instanceof Function)
            actionButton = actionButton(this.params.data);
        this.actionButton = actionButton;
    }
}
BarActionButtonCellRenderer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarActionButtonCellRenderer, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarActionButtonCellRenderer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarActionButtonCellRenderer, selector: "ng-component", ngImport: i0, template: '<bar-action-button [item]="actionButton" [zeroWhiteLineIfHidden]="true"></bar-action-button>', isInline: true, dependencies: [{ kind: "component", type: i1$1.BarActionButtonComponent, selector: "bar-action-button", inputs: ["item", "zeroWhiteLineIfHidden"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarActionButtonCellRenderer, decorators: [{
            type: Component,
            args: [{
                    template: '<bar-action-button [item]="actionButton" [zeroWhiteLineIfHidden]="true"></bar-action-button>'
                }]
        }] });

/** Checkbox cell renderer component. */
class BarCheckboxCellRenderer {
    agInit(params) {
        this.params = params;
        this.value = this.params.value;
    }
    refresh(params) {
        return false;
    }
}
BarCheckboxCellRenderer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCheckboxCellRenderer, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarCheckboxCellRenderer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarCheckboxCellRenderer, selector: "ng-component", ngImport: i0, template: '<mat-checkbox [ngModel]="value" [disabled]="true"><span class="sr-only">{{params.text}}</span></mat-checkbox>', isInline: true, dependencies: [{ kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarCheckboxCellRenderer, decorators: [{
            type: Component,
            args: [{
                    template: '<mat-checkbox [ngModel]="value" [disabled]="true"><span class="sr-only">{{params.text}}</span></mat-checkbox>'
                }]
        }] });

/** Will render a date using the Angular common pipe */
class BarDateStringCellRenderer {
    refresh(params) {
        return false;
    }
    agInit(params) {
        this.params = params;
        this.format = this.params.format;
    }
}
BarDateStringCellRenderer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarDateStringCellRenderer, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarDateStringCellRenderer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarDateStringCellRenderer, selector: "ng-component", ngImport: i0, template: `{{ params.value | date: format }}`, isInline: true, dependencies: [{ kind: "pipe", type: i1$3.DatePipe, name: "date" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarDateStringCellRenderer, decorators: [{
            type: Component,
            args: [{
                    template: `{{ params.value | date: format }}`
                }]
        }] });

/** Will render an icon in an ag-grid cell. */
class BarIconCellRenderer {
    refresh(params) {
        return false;
    }
    agInit(params) {
        this.params = params;
        this.fontIcon = this.defineFontIcon();
        this.fontSet = this.defineFontSet();
        this.title = this.defineTitle();
        this.color = this.defineColor();
    }
    defineFontIcon() {
        const fontIcon = this.params.fontIcon;
        if (fontIcon != null) {
            if (fontIcon instanceof Function) {
                return fontIcon(this.params.data);
            }
            else {
                return fontIcon;
            }
        }
        else {
            return null;
        }
    }
    defineFontSet() {
        const fontSet = this.params.fontSet;
        if (fontSet != null) {
            if (fontSet instanceof Function) {
                return fontSet(this.params.data);
            }
            else {
                return fontSet;
            }
        }
        else {
            return null;
        }
    }
    defineTitle() {
        const title = this.params.title;
        if (title != null) {
            if (title instanceof Function) {
                return title(this.params.data);
            }
            else {
                return title;
            }
        }
        else {
            // by default use the field content
            return this.params.data[this.params.colDef.field];
        }
    }
    defineColor() {
        const color = this.params.color;
        if (color != null) {
            if (color instanceof Function) {
                return color(this.params.data);
            }
            else {
                return color;
            }
        }
        else {
            return null;
        }
    }
}
BarIconCellRenderer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIconCellRenderer, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarIconCellRenderer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarIconCellRenderer, selector: "ng-component", ngImport: i0, template: '<mat-icon [fontSet]="fontSet" [fontIcon]="fontIcon" [matTooltip]="title" [color]="color"></mat-icon>', isInline: true, dependencies: [{ kind: "directive", type: i5$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarIconCellRenderer, decorators: [{
            type: Component,
            args: [{
                    template: '<mat-icon [fontSet]="fontSet" [fontIcon]="fontIcon" [matTooltip]="title" [color]="color"></mat-icon>'
                }]
        }] });

/** BAR ag-grid cell renderer to render a BAR (hyper)link. */
class BarLinkCellRenderer {
    refresh(params) {
        return false;
    }
    agInit(params) {
        this.params = params;
        const linkAttr = this.params.link;
        if (linkAttr != null) {
            let link;
            // function in case computed (which is the default)
            if (linkAttr instanceof Function) {
                link = linkAttr(this.params.data);
            }
            else {
                link = linkAttr;
            }
            if (link.content == null && this.params.colDef.field != null && this.params.colDef.field.length > 0) {
                // if the content is left empty by default we take the field
                link.content = this.params.data[this.params.colDef.field];
            }
            this.link = link;
        }
    }
}
BarLinkCellRenderer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLinkCellRenderer, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarLinkCellRenderer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarLinkCellRenderer, selector: "ng-component", ngImport: i0, template: '<bar-link [item]="link" [zeroWhiteLineIfHidden]="true"></bar-link>', isInline: true, dependencies: [{ kind: "component", type: i1$1.BarLinkComponent, selector: "bar-link", inputs: ["item", "linkClass", "ommitCssClass", "zeroWhiteLineIfHidden"], outputs: ["clicked"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarLinkCellRenderer, decorators: [{
            type: Component,
            args: [{
                    template: '<bar-link [item]="link" [zeroWhiteLineIfHidden]="true"></bar-link>'
                }]
        }] });

/** BAR ag-grid cell renderer to render a BAR action button. */
class BarMenuButtonCellRenderer {
    refresh(params) {
        return false;
    }
    agInit(params) {
        this.params = params;
    }
}
BarMenuButtonCellRenderer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMenuButtonCellRenderer, deps: [], target: i0.ɵɵFactoryTarget.Component });
BarMenuButtonCellRenderer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarMenuButtonCellRenderer, selector: "ng-component", ngImport: i0, template: `<bar-menu-button
        *ngIf="!params.hidden"
        [content]="params.content"
        [items]="params.items"
        [disabled]="params.disabled"
        [tooltip]="params.tooltip"
        [iconClass]="params.iconClass"
    >
    </bar-menu-button>`, isInline: true, dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$1.BarMenuButtonComponent, selector: "bar-menu-button", inputs: ["content", "disabled", "tooltip", "iconClass", "type", "items"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarMenuButtonCellRenderer, decorators: [{
            type: Component,
            args: [{
                    template: `<bar-menu-button
        *ngIf="!params.hidden"
        [content]="params.content"
        [items]="params.items"
        [disabled]="params.disabled"
        [tooltip]="params.tooltip"
        [iconClass]="params.iconClass"
    >
    </bar-menu-button>`
                }]
        }] });

class BarAgGridGvkComponent {
    constructor(toast, gvkManager) {
        this.toast = toast;
        this.gvkManager = gvkManager;
        /*
         * If the settings should be automatically applied upon grid OnInit
         */
        this.autoApply = true;
        /*
         * Type of storage (default (= remote + browser session), remote (= only remote db), session (= only browser session))
         */
        this.storageMode = BarGvkStorageMode.Default;
        /*
         * Optionally apply the filters set in AG Grid.
         */
        this.applyFilters = false;
        /*
         * When the initialized method is called we return an event when completed. This way the application can call an auto resize (or ...) if need be.
         */
        this.initialized = new EventEmitter();
        // NOTE we use a replay subject to remember old events which have already been emitted
        this.rowDataChanged$ = new ReplaySubject();
    }
    ngOnInit() {
        if (this.autoApply) {
            this.apply(true);
        }
    }
    ngOnChanges(changes) {
        if (changes.gridApi && this.gridApi) {
            this.gridApi.addGlobalListener((e) => {
                // here we bind to the event and translate it to our own event
                if (e === 'rowDataChanged') {
                    this.rowDataChanged$.next();
                }
            });
        }
    }
    ngOnDestroy() {
        this.rowDataChanged$.complete();
    }
    /*
     * Initialize the grid to the default settings
     */
    init() {
        this.columnApi.resetColumnState();
        if (this.applyFilters) {
            this.gridApi.setFilterModel(null);
        }
        this.initialized.emit();
    }
    /*
     * Save the current config to gvk
     */
    save() {
        // get current state
        const state = {
            columnState: this.columnApi.getColumnState()
        };
        if (this.applyFilters) {
            state.filters = this.gridApi.getFilterModel();
        }
        // store state to gvk with provided key
        this.gvkManager
            .setItem(this.gridKey, state)
            .then(() => {
            this.toast.addMessage({
                text: 'Grid instellingen werden bewaard.',
                type: BarToastMessageType.Success
            });
        })
            .catch(() => {
            this.toast.addMessage({
                text: 'Grid instellingen konden niet bewaard worden.',
                type: BarToastMessageType.Error
            });
        });
    }
    /*
     * Apply the config saved in gvk
     */
    apply(initialAutoApply = false) {
        this.gvkManager
            .getItem(this.gridKey)
            .then((state) => {
            if (!state)
                return;
            // apply filters when first data is set, otherwise the filter has no use
            if (initialAutoApply && this.applyFilters) {
                // wait for data to load before applying filters
                this.rowDataChanged$.subscribe(() => {
                    this.gridApi.setFilterModel(state.filters);
                });
            }
            else if (!initialAutoApply) {
                // when preset apply manually we just set the filters.
                this.gridApi.setFilterModel(state.filters);
            }
            // apply column state to the grid
            this.columnApi.applyColumnState({ state: state.columnState, applyOrder: true });
            if (!initialAutoApply) {
                this.toast.addMessage({
                    text: 'Grid instellingen werden toegepast.',
                    type: BarToastMessageType.Success
                });
            }
        })
            .catch(() => {
            if (!initialAutoApply) {
                this.toast.addMessage({
                    text: 'Grid instellingen konden niet gevonden worden.',
                    type: BarToastMessageType.Error
                });
            }
        });
    }
}
BarAgGridGvkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridGvkComponent, deps: [{ token: i1$1.BarToastMessageService }, { token: i2$3.BarGvkManager }], target: i0.ɵɵFactoryTarget.Component });
BarAgGridGvkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BarAgGridGvkComponent, selector: "bar-ag-grid-gvk", inputs: { gridApi: "gridApi", columnApi: "columnApi", gridKey: "gridKey", autoApply: "autoApply", storageMode: "storageMode", applyFilters: "applyFilters" }, outputs: { initialized: "initialized" }, usesOnChanges: true, ngImport: i0, template: "<button mat-icon-button\r\n        matTooltip=\"Grid instellingen beheren\"\r\n        type=\"button\"\r\n        [matMenuTriggerFor]=\"menu\">\r\n    <mat-icon aria-hidden=\"false\" class=\"fa fa-cog\" aria-label=\"Grid instellingen beheren\"></mat-icon>\r\n</button>\r\n<mat-menu #menu=\"matMenu\">\r\n    <button mat-menu-item\r\n            (click)=\"init()\">\r\n        <span aria-hidden=\"true\" class=\"fa fa-undo mr-2\"></span>\r\n        <span>Instellingen initialiseren</span>\r\n    </button>\r\n    <button mat-menu-item\r\n            (click)=\"apply()\">\r\n        <span aria-hidden=\"true\" class=\"fa fa-check mr-2\"></span>\r\n        <span>Mijn instellingen toepassen</span>\r\n    </button>\r\n    <button mat-menu-item\r\n            (click)=\"save()\">\r\n        <span aria-hidden=\"true\" class=\"fa fa-save mr-2\"></span>\r\n        <span>Mijn instellingen bewaren</span>\r\n    </button>\r\n</mat-menu>\r\n", dependencies: [{ kind: "component", type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i4$1.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i4$1.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i4$1.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i5$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i6.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridGvkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bar-ag-grid-gvk', template: "<button mat-icon-button\r\n        matTooltip=\"Grid instellingen beheren\"\r\n        type=\"button\"\r\n        [matMenuTriggerFor]=\"menu\">\r\n    <mat-icon aria-hidden=\"false\" class=\"fa fa-cog\" aria-label=\"Grid instellingen beheren\"></mat-icon>\r\n</button>\r\n<mat-menu #menu=\"matMenu\">\r\n    <button mat-menu-item\r\n            (click)=\"init()\">\r\n        <span aria-hidden=\"true\" class=\"fa fa-undo mr-2\"></span>\r\n        <span>Instellingen initialiseren</span>\r\n    </button>\r\n    <button mat-menu-item\r\n            (click)=\"apply()\">\r\n        <span aria-hidden=\"true\" class=\"fa fa-check mr-2\"></span>\r\n        <span>Mijn instellingen toepassen</span>\r\n    </button>\r\n    <button mat-menu-item\r\n            (click)=\"save()\">\r\n        <span aria-hidden=\"true\" class=\"fa fa-save mr-2\"></span>\r\n        <span>Mijn instellingen bewaren</span>\r\n    </button>\r\n</mat-menu>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.BarToastMessageService }, { type: i2$3.BarGvkManager }]; }, propDecorators: { gridApi: [{
                type: Input
            }], columnApi: [{
                type: Input
            }], gridKey: [{
                type: Input
            }], autoApply: [{
                type: Input
            }], storageMode: [{
                type: Input
            }], applyFilters: [{
                type: Input
            }], initialized: [{
                type: Output
            }] } });

class BarSelectCellEditorIcon {
}

/** Lifecycle hook for BAR ag grid module. */
class BarAgGridInitializedHook {
    constructor(state) {
        this.state = state;
        this._framework = true;
    }
    run() {
        if (this.state != null) {
            // set ag-Grid license key after BAR is initialized
            try {
                LicenseManager.setLicenseKey(this.state.config.agGridLicense);
            }
            catch (error) {
                console.warn('License manager not found, are you sure ag-Grid has been added to the project?');
            }
        }
    }
}
BarAgGridInitializedHook.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridInitializedHook, deps: [{ token: i1$4.BarCoreStateService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
BarAgGridInitializedHook.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridInitializedHook });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridInitializedHook, decorators: [{
            type: Injectable
        }], ctorParameters: function () {
        return [{ type: i1$4.BarCoreStateService, decorators: [{
                        type: Optional
                    }] }];
    } });

// IMPORTANT!
// 20/07/2021
// Charts translations are not yet translated to NL as charts are currently unused.
const AG_GRID_LOCALE_NL = {
    // Set Filter
    selectAll: '(Alles selecteren)',
    selectAllSearchResults: '(Selecteer alle zoekresultaten)',
    searchOoo: 'Zoeken...',
    blanks: '(Leeg)',
    noMatches: 'Geen overeenkomsten',
    // Number Filter & Text Filter
    filterOoo: 'Filteren...',
    equals: 'Gelijk',
    notEqual: 'Verschillend van',
    empty: 'Kiezen',
    // Number Filter    
    lessThan: 'Kleiner dan',
    greaterThan: 'Groter dan',
    lessThanOrEqual: 'Kleiner of gelijk aan',
    greaterThanOrEqual: 'Groter of gelijk aan',
    inRange: 'Binnen bereik',
    inRangeStart: 'tot',
    inRangeEnd: 'vanaf',
    // Text Filter
    contains: 'Bevat',
    notContains: 'Bevat niet',
    startsWith: 'Begint met',
    endsWith: 'Eindigt met',
    blank: 'Leeg',
    notBlank: 'Niet leeg',
    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',
    // Filter Conditions
    andCondition: 'EN',
    orCondition: 'OF',
    // Filter Buttons
    applyFilter: 'Toepassen...',
    resetFilter: 'Reset',
    clearFilter: 'Leegmaken',
    cancelFilter: 'Annuleren',
    // Filter Titles
    textFilter: 'Tekst filter',
    numberFilter: 'Nummer filter',
    dateFilter: 'Datum filter',
    setFilter: 'Filter instellen',
    // Side Bar
    columns: 'Kolommen',
    filters: 'Filters',
    // columns tool panel
    pivotMode: 'Pivoteer-modus',
    groups: 'Groepen',
    rowGroupColumnsEmptyMessage: 'Sleep hier kolommen om te groeperen',
    values: 'Waarden',
    valueColumnsEmptyMessage: 'Sleep hier kolommen om samen te voegen',
    pivots: 'Gepivoteerde kolommen',
    pivotColumnsEmptyMessage: 'Sleep hier kolommen om te pivoteren',
    // Header of the Default Group Column
    group: 'Groep',
    // Other
    loadingOoo: 'Laden...',
    noRowsToShow: 'Er zijn geen gegevens',
    enabled: 'Ingeschakeld',
    // Menu
    pinColumn: 'Kolom vastpinnen',
    pinLeft: 'Links vastpinnen',
    pinRight: 'Rechts vastpinnen',
    noPin: 'Niet vastpinnen',
    valueAggregation: 'Gezamelijke waarde',
    autosizeThiscolumn: 'Grootte van deze kolom automatisch aanpassen',
    autosizeAllColumns: 'Grootte van alle kolommen automatisch aanpassen',
    groupBy: 'Groeperen op',
    ungroupBy: 'Degroeperen',
    resetColumns: 'Kolommen resetten',
    expandAll: 'Alles uitklappen',
    collapseAll: 'Alles inklappen',
    copy: 'Kopiëren',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Kopiëren met hoofding',
    copyWithGroupHeaders: 'Kopiëren met groep hoofding',
    paste: 'Plakken',
    ctrlV: 'Ctrl+V',
    export: 'Exporteren',
    csvExport: 'Exporteren naar csv',
    excelExport: 'Exporteren naar excel',
    // Enterprise Menu Aggregation and Status Bar
    sum: 'Som',
    min: 'Min.',
    max: 'Max.',
    none: 'Geen',
    count: 'Aantal',
    avg: 'Gemiddelde',
    filteredRows: 'Gefilterd',
    selectedRows: 'Geselecteerd',
    totalRows: 'Totaal aantal',
    totalAndFilteredRows: 'Rijen',
    more: 'Meer',
    to: 'tot',
    of: 'van',
    page: 'Pagina',
    nextPage: 'Volgende pagina',
    lastPage: 'Laatste pagina',
    firstPage: 'Eerste pagina',
    previousPage: 'Vorige pagina',
    // Pivoting
    pivotColumnGroupTotals: 'Totaal',
    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',
    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',
    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',
    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',
    line: 'Line',
    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',
    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',
    histogramChart: 'Histogram',
    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',
    // ARIA
    ariaHidden: 'verborgen',
    ariaVisible: 'zichtbaar',
    ariaChecked: 'aangevinkt',
    ariaUnchecked: 'uitgevinkt',
    ariaIndeterminate: 'onbepaald',
    ariaColumnSelectAll: 'Toggle selecteer alle kolommen',
    ariaInputEditor: 'Input editor',
    ariaDateFilterInput: 'Datum filter input',
    ariaFilterInput: 'Filter input',
    ariaFilterColumnsInput: 'Filter kolommen input',
    ariaFilterValue: 'Filter waarde',
    ariaFilterFromValue: 'Filter vanaf waarde',
    ariaFilterToValue: 'Filter tot waarde',
    ariaFilteringOperator: 'Filter operator',
    ariaColumnToggleVisibility: 'kolom toggle zichtbaarheid',
    ariaColumnGroupToggleVisibility: 'Groepkolom toggle zichtbaarheid',
    ariaRowSelect: 'Druk SPATIE om deze rij te selecteren',
    ariaRowDeselect: 'Druk SPATIE om deze rij te deselecteren',
    ariaRowToggleSelection: 'Druk SPATIE om de rijselectie te togglen',
    ariaRowSelectAll: 'Druk SPATIE om alle-rijselectie te togglen',
    ariaSearch: 'Zoeken',
    ariaSearchFilterValues: 'Zoek filter waarden',
    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: '.',
    decimalSeparator: ','
};
var translations = {
    CHOOSE_DATE: 'Kies een datum',
    LOCALE: AG_GRID_LOCALE_NL
};

// NOTE we use a startupservice here for the translations because in disconnected modus it should work (without initialized hooks)
class BarAgGridStartupService {
    constructor(translate) {
        this.translate = translate;
    }
    load() {
        this.translate.addTranslations('DOMAIN_BAR_AG_GRID', translations);
        return Promise.resolve();
    }
}
BarAgGridStartupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridStartupService, deps: [{ token: i1$2.BarI18nService }], target: i0.ɵɵFactoryTarget.Injectable });
BarAgGridStartupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridStartupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridStartupService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.BarI18nService }]; } });

function agGridStartupServiceFactory(startup) {
    // AOT-proof setup: https://github.com/angular/angular-cli/issues/5158
    const fn = () => startup.load();
    return fn;
}
class BarAgGridModule {
    /** Import through this function in the app root module */
    static forRoot() {
        return {
            ngModule: BarAgGridModule,
            // following services need to be singleton over all modules
            providers: [
                {
                    provide: BAR_INITIALIZED,
                    useClass: BarAgGridInitializedHook,
                    multi: true
                },
                BarAgGridStartupService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: agGridStartupServiceFactory,
                    deps: [BarAgGridStartupService],
                    multi: true
                }
            ]
        };
    }
}
BarAgGridModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BarAgGridModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridModule, declarations: [BarAgGridGvkComponent], imports: [MatIconModule, MatMenuModule, MatTooltipModule, MatButtonModule, BarI18nModule], exports: [BarAgGridGvkComponent] });
BarAgGridModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridModule, imports: [MatIconModule, MatMenuModule, MatTooltipModule, MatButtonModule, BarI18nModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BarAgGridGvkComponent],
                    exports: [BarAgGridGvkComponent],
                    imports: [MatIconModule, MatMenuModule, MatTooltipModule, MatButtonModule, BarI18nModule]
                }]
        }] });

// needed for NG compilation otherwise it complains
// https://github.com/angular/angular/issues/23609#issuecomment-510871378
// export const barAgGridCellEditorsModuleTranslateModuleForChild = TranslateModule.forChild();
class BarAgGridCellEditorsModule {
}
BarAgGridCellEditorsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellEditorsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BarAgGridCellEditorsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellEditorsModule, declarations: [BarAutoNumericCellEditor, BarCheckboxCellEditor, BarInputCellEditor, BarSelectCellEditor, BarDateTimeCellEditor, BarTextareaCellEditor], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BarI18nModule,
        NgSelectModule,
        NgOptionHighlightModule,
        OwlDateTimeModule,
        MatCheckboxModule,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        BarControlsModule], exports: [BarAutoNumericCellEditor, BarCheckboxCellEditor, BarInputCellEditor, BarSelectCellEditor, BarDateTimeCellEditor, BarTextareaCellEditor] });
BarAgGridCellEditorsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellEditorsModule, imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BarI18nModule,
        NgSelectModule,
        NgOptionHighlightModule,
        OwlDateTimeModule,
        MatCheckboxModule,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        BarControlsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellEditorsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BarAutoNumericCellEditor, BarCheckboxCellEditor, BarInputCellEditor, BarSelectCellEditor, BarDateTimeCellEditor, BarTextareaCellEditor],
                    exports: [BarAutoNumericCellEditor, BarCheckboxCellEditor, BarInputCellEditor, BarSelectCellEditor, BarDateTimeCellEditor, BarTextareaCellEditor],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        BarI18nModule,
                        NgSelectModule,
                        NgOptionHighlightModule,
                        OwlDateTimeModule,
                        MatCheckboxModule,
                        MatInputModule,
                        MatFormFieldModule,
                        MatIconModule,
                        MatButtonModule,
                        MatTooltipModule,
                        BarControlsModule
                    ]
                }]
        }] });

class BarAgGridCellRenderersModule {
}
BarAgGridCellRenderersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellRenderersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BarAgGridCellRenderersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellRenderersModule, declarations: [BarCheckboxCellRenderer,
        BarActionButtonCellRenderer,
        BarDateStringCellRenderer,
        BarIconCellRenderer,
        BarLinkCellRenderer,
        BarMenuButtonCellRenderer], imports: [CommonModule, FormsModule, BarI18nModule, MatCheckboxModule, MatTooltipModule, MatIconModule, BarControlsModule], exports: [BarCheckboxCellRenderer,
        BarActionButtonCellRenderer,
        BarDateStringCellRenderer,
        BarIconCellRenderer,
        BarLinkCellRenderer,
        BarMenuButtonCellRenderer] });
BarAgGridCellRenderersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellRenderersModule, imports: [CommonModule, FormsModule, BarI18nModule, MatCheckboxModule, MatTooltipModule, MatIconModule, BarControlsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridCellRenderersModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BarCheckboxCellRenderer,
                        BarActionButtonCellRenderer,
                        BarDateStringCellRenderer,
                        BarIconCellRenderer,
                        BarLinkCellRenderer,
                        BarMenuButtonCellRenderer
                    ],
                    exports: [
                        BarCheckboxCellRenderer,
                        BarActionButtonCellRenderer,
                        BarDateStringCellRenderer,
                        BarIconCellRenderer,
                        BarLinkCellRenderer,
                        BarMenuButtonCellRenderer
                    ],
                    imports: [CommonModule, FormsModule, BarI18nModule, MatCheckboxModule, MatTooltipModule, MatIconModule, BarControlsModule]
                }]
        }] });

/** AG grid functionality */
class BarAgGridService {
    constructor(translate) {
        this.translate = translate;
    }
    /** Gets a locale text based on params. */
    getLocaleText(params) {
        const gridKey = 'DOMAIN_BAR_AG_GRID.LOCALE.' + params.key;
        const instantTranslation = this.translate.instant(gridKey);
        return instantTranslation !== gridKey ? instantTranslation : params.defaultValue;
    }
}
BarAgGridService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridService, deps: [{ token: i1$2.BarI18nService }], target: i0.ɵɵFactoryTarget.Injectable });
BarAgGridService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BarAgGridService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$2.BarI18nService }]; } });

/*
 * Public API Surface of @lvflanders/bar-ng-ag-grid
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BarActionButtonCellRenderer, BarAgGridCellEditorsModule, BarAgGridCellRenderersModule, BarAgGridGvkComponent, BarAgGridModule, BarAgGridService, BarAutoNumericCellEditor, BarCheckboxCellEditor, BarCheckboxCellRenderer, BarDateStringCellRenderer, BarDateTimeCellEditor, BarIconCellRenderer, BarInputCellEditor, BarLinkCellRenderer, BarMenuButtonCellRenderer, BarSelectCellEditor, BarSelectCellEditorIcon, BarTextareaCellEditor, agGridStartupServiceFactory };
//# sourceMappingURL=lvflanders-bar-ng-ag-grid.mjs.map
